import { Record, Union } from "../../fable_modules/fable-library.3.7.20/Types.js";
import { list_type, equals as equals_2, int32_type, tuple_type, array_type, record_type, class_type, option_type, lambda_type, unit_type, bool_type, union_type, string_type } from "../../fable_modules/fable-library.3.7.20/Reflection.js";
import { dayOfWeek, create, day as day_1, month as month_2, year } from "../../fable_modules/fable-library.3.7.20/DateOnly.js";
import { maxValue, minValue, fromDateTimeOffset, toString as toString_1, day as day_2, month as month_3, year as year_1, dayOfWeek as dayOfWeek_1, op_Addition, date as date_5, now as now_1, equals, addDays } from "../../fable_modules/fable-library.3.7.20/Date.js";
import * as react from "react";
import { getMaterialIcon, Size, getMaterialIconBySize, dotsLoading } from "../../ViewUtils.js";
import { MessageKind, customMessage, info as info_1, warning, error } from "../../Components/Message/Message.js";
import { renderTable, renderSideTable } from "../../Components/Table/Table.js";
import { empty, singleton, append, delay, toList } from "../../fable_modules/fable-library.3.7.20/Seq.js";
import { bind, map, defaultArg, value as value_2 } from "../../fable_modules/fable-library.3.7.20/Option.js";
import { head, mapIndexed, exists, item, fold, tryLast, tryHead, filter, choose, tryFind as tryFind_1, length, singleton as singleton_2, map as map_1, isEmpty, ofArray } from "../../fable_modules/fable-library.3.7.20/List.js";
import { toString } from "../../fable_modules/fable-library.3.7.20/Long.js";
import { NumberMenuProps, renderNumberMenu, usesProvisioningViaSvea as usesProvisioningViaSvea_1, getProductType, toDisplayDate } from "./Common.js";
import { loge, logei, logii, logwi, Locale_get_FromSelectedLanguage, DateTimeOffsetExtensions_yyyy_MM_ddTHH_mm_ss_fffZ, DateTimeExtensions_yyyy_MM_ddTHH_mm_ssZ, stackClasses, strToOpt, DateTimeExtensions_toDateHHmm, Locale$reflection, DateTimeOffsetExtensions_toDateHHmmss, optToStr } from "../../Utils.js";
import { PageinationProps$1, Pagination } from "../../Components/Pagination/Pagination.js";
import { Product, ProductModule_toTranslation, Product$reflection, IsoCountryCode$reflection } from "../../DomainTypes.js";
import { FunctionComponent_Of_Z5A158BBF } from "../../fable_modules/Fable.React.7.4.3/Fable.React.FunctionComponent.fs.js";
import { useDispatch, useSelector } from "../../Redux/Store.js";
import { LoadState_zip3, LoadState$2$reflection, GlobalDependencies$reflection, LoadState$2, SaveStatus$reflection, Flatpickr_OnChangeOption, SaveStatus as SaveStatus_1, getTranslationFrom } from "../../Global.js";
import { create as create_1 } from "../../fable_modules/fable-library.3.7.20/TimeSpan.js";
import { TextProps$1, TextProps$1_GetDefault, render as render_1 } from "../../Components/StatefulFormFields/Text.js";
import { Browser_Types_Event__Event_get_Value } from "../../fable_modules/Fable.React.7.4.3/Fable.React.Extensions.fs.js";
import { isImsiOrIcc, correctPhoneNumber } from "../../Validation/Telecom.js";
import { DateOptions, DateOptions_get_getDefault, inputDate } from "../../Components/FormFields/FormFields.js";
import { EnableRanges, Placeholder, custom, OnChange as OnChange_2, Locale as Locale_1, FormatDateBy, Value as Value_2, TimeTwentyFour, EnableTimePicker, Id as Id_3 } from "../../fable_modules/Fable.React.Flatpickr.3.0.0/Flatpickr.fs.js";
import { printf, toText } from "../../fable_modules/fable-library.3.7.20/String.js";
import { renderWithButtonProps, render as render_2 } from "../../Components/Modals/Standard.js";
import { modal, ModalSize } from "../../Components/Modal/Modal.js";
import { partialApply, int32ToString, equals as equals_1, uncurry } from "../../fable_modules/fable-library.3.7.20/Util.js";
import { FSharpResult$2 } from "../../fable_modules/fable-library.3.7.20/Choice.js";
import { HTMLAttr } from "../../fable_modules/Fable.React.7.4.3/Fable.React.Props.fs.js";
import { keyValueList } from "../../fable_modules/fable-library.3.7.20/MapUtil.js";
import { SearchSuggestionProps$1, render as render_3 } from "../../Components/SearchSuggestion/SearchSuggestion.js";
import { ButtonKind, wrappedButton, ButtonProps_get_getDefault, secondary, ButtonProps, defaultProps } from "../../Components/Button/Button.js";
import { startImmediate } from "../../fable_modules/fable-library.3.7.20/Async.js";
import { singleton as singleton_1 } from "../../fable_modules/fable-library.3.7.20/AsyncBuilder.js";
import { renderAsModalThenSaveState, render as render_4 } from "../../Components/Modals/SaveState/SaveState.js";
import { Helpers_equalsButFunctions } from "../../fable_modules/Fable.React.7.4.3/Fable.React.Helpers.fs.js";
import { NumberHistoryDTO_SortByActiveFrom_285C6A16, NumberHistory_OfDTO, Sim$reflection, NumberHistory$reflection } from "../Subscriptions/Common.js";
import { getPortationRequestDTO, DeactivateNumberModal as DeactivateNumberModal_1, getSelectedNumberHistory, getNetworkContractNr, OrderDTO$reflection, DeactivateNumberModal$reflection, TrafficRedirect$reflection, NumberRegisterModificationDTO, NumberRegisterModificationDTO$reflection } from "./Model.js";
import { warning as warning_1, error as error_1 } from "../../Redux/Reducers/ModalsReducer.js";
import { ValidatedUrlModule_value, addClientReference, Http_get_ExtraCoders, ValidatedUrlModule_create } from "../../HttpV2.js";
import { UrlKind } from "../../HttpV2.js";
import { CaseStrategy } from "../../fable_modules/Thoth.Json.10.2.0/Types.fs.js";
import { Auto_generateBoxedDecoder_79988AEF, fromString } from "../../fable_modules/Thoth.Json.10.2.0/Decode.fs.js";
import { Http_request, Http_method, Http_withCredentials, Http_send } from "../../fable_modules/Fable.SimpleHttp.3.0.0/Http.fs.js";
import { HttpMethod } from "../../fable_modules/Fable.SimpleHttp.3.0.0/Types.fs.js";
import { MessageType, render as render_5 } from "../../Components/Modals/InfoMessage/InfoMessage.js";
import { ContractType$reflection, Contract$reflection } from "../Invoicee/Common.js";
import { TelecomOrderProps, view as view_1 } from "../TelecomOrder/View.js";
import { empty as empty_1, add, tryFind } from "../../fable_modules/fable-library.3.7.20/Map.js";
import { saveNumberRegisterModification as saveNumberRegisterModification_1, saveDeactivateNumber as saveDeactivateNumber_1, saveCreateInportation as saveCreateInportation_1, loadNetworkIntegrationNr as loadNetworkIntegrationNr_1, loadNumberHistory as loadNumberHistory_1, loadTrafficRedirects as loadTrafficRedirects_1, loadSim as loadSim_1, saveStatusOrder as saveStatusOrder_1, loadOrders as loadOrders_1, loadSearchIccOrImsi, saveActivateNumber as saveActivateNumber_1 } from "./Api.js";
import { PortationBoxProps, RenderStyle, renderPortationBox } from "../Portation/PortationBox.js";
import { UTC__get_Day, UTC__get_Month, UTC__get_Year, UTCModule_date, UTCModule_addDays, UTCModule_now, UTCModule_addYears } from "../../fable_modules/Svea.Dry.Fable.1.0.4/Time.fs.js";
import { DateTimeOffset_$007CEnded$007C_$007C, DateTimeOffset_$007CStartsInFuture$007C_$007C, DateTimeOffset_$007COngoing$007C_$007C, DateTimeOffset_$007CEndsInFuture$007C_$007C } from "../../DateUtils.js";
import { PortationTableProps, InitialState, renderPortationTable } from "../Portation/PortationTable.js";
import { PlacedOrdersSectionProps, renderPlacedOrdersSection } from "./PendingOrders.js";
import "../../../src/Containers/Telecom/View.scss";


export class DayInfo extends Union {
    constructor(tag, ...fields) {
        super();
        this.tag = (tag | 0);
        this.fields = fields;
    }
    cases() {
        return ["Helgdag", "Afton", "Veckoslut", "Vardag"];
    }
}

export function DayInfo$reflection() {
    return union_type("Containers.Telecom.View.DayInfo", [], DayInfo, () => [[["Item", string_type]], [["Item", string_type]], [["Item", string_type]], []]);
}

export function SweHoliday_getSwedishDayInfo(date) {
    const y = year(date) | 0;
    const m = month_2(date) | 0;
    const d = day_1(date) | 0;
    let easterSunday;
    const a = (y % 19) | 0;
    const b = (~(~(y / 100))) | 0;
    const c = (y % 100) | 0;
    const h = ((((((19 * a) + b) - (~(~(b / 4)))) - (~(~(((b - (~(~((b + 8) / 25)))) + 1) / 3)))) + 15) % 30) | 0;
    const l = (((((32 + (2 * (b % 4))) + (2 * (~(~(c / 4))))) - h) - (c % 4)) % 7) | 0;
    const m_1 = (~(~(((a + (11 * h)) + (22 * l)) / 451))) | 0;
    easterSunday = create(y, ~(~((((h + l) - (7 * m_1)) + 114) / 31)), ((((h + l) - (7 * m_1)) + 114) % 31) + 1);
    let midsommarafton;
    const firstPossible = create(y, 6, 19);
    midsommarafton = addDays(firstPossible, ((5 - dayOfWeek(firstPossible)) + 7) % 7);
    const midsommardagen = addDays(midsommarafton, 1);
    let allaHelgonsDag;
    const firstOct31 = create(y, 10, 31);
    allaHelgonsDag = addDays(firstOct31, ((6 - dayOfWeek(firstOct31)) + 7) % 7);
    const matchValue = [m, d];
    let pattern_matching_result;
    if (matchValue[0] === 1) {
        if (matchValue[1] === 1) {
            pattern_matching_result = 0;
        }
        else if (matchValue[1] === 5) {
            pattern_matching_result = 1;
        }
        else if (matchValue[1] === 6) {
            pattern_matching_result = 2;
        }
        else if (equals(date, addDays(easterSunday, -2))) {
            pattern_matching_result = 9;
        }
        else if (equals(date, addDays(easterSunday, -1))) {
            pattern_matching_result = 10;
        }
        else if (equals(date, easterSunday)) {
            pattern_matching_result = 11;
        }
        else if (equals(date, addDays(easterSunday, 1))) {
            pattern_matching_result = 12;
        }
        else if (equals(date, addDays(easterSunday, 39))) {
            pattern_matching_result = 13;
        }
        else if (equals(date, addDays(easterSunday, 49))) {
            pattern_matching_result = 14;
        }
        else if (equals(date, midsommarafton)) {
            pattern_matching_result = 15;
        }
        else if (equals(date, midsommardagen)) {
            pattern_matching_result = 16;
        }
        else if (equals(date, allaHelgonsDag)) {
            pattern_matching_result = 17;
        }
        else if (dayOfWeek(date) === 6) {
            pattern_matching_result = 18;
        }
        else if (dayOfWeek(date) === 0) {
            pattern_matching_result = 19;
        }
        else {
            pattern_matching_result = 20;
        }
    }
    else if (matchValue[0] === 5) {
        if (matchValue[1] === 1) {
            pattern_matching_result = 3;
        }
        else if (equals(date, addDays(easterSunday, -2))) {
            pattern_matching_result = 9;
        }
        else if (equals(date, addDays(easterSunday, -1))) {
            pattern_matching_result = 10;
        }
        else if (equals(date, easterSunday)) {
            pattern_matching_result = 11;
        }
        else if (equals(date, addDays(easterSunday, 1))) {
            pattern_matching_result = 12;
        }
        else if (equals(date, addDays(easterSunday, 39))) {
            pattern_matching_result = 13;
        }
        else if (equals(date, addDays(easterSunday, 49))) {
            pattern_matching_result = 14;
        }
        else if (equals(date, midsommarafton)) {
            pattern_matching_result = 15;
        }
        else if (equals(date, midsommardagen)) {
            pattern_matching_result = 16;
        }
        else if (equals(date, allaHelgonsDag)) {
            pattern_matching_result = 17;
        }
        else if (dayOfWeek(date) === 6) {
            pattern_matching_result = 18;
        }
        else if (dayOfWeek(date) === 0) {
            pattern_matching_result = 19;
        }
        else {
            pattern_matching_result = 20;
        }
    }
    else if (matchValue[0] === 6) {
        if (matchValue[1] === 6) {
            pattern_matching_result = 4;
        }
        else if (equals(date, addDays(easterSunday, -2))) {
            pattern_matching_result = 9;
        }
        else if (equals(date, addDays(easterSunday, -1))) {
            pattern_matching_result = 10;
        }
        else if (equals(date, easterSunday)) {
            pattern_matching_result = 11;
        }
        else if (equals(date, addDays(easterSunday, 1))) {
            pattern_matching_result = 12;
        }
        else if (equals(date, addDays(easterSunday, 39))) {
            pattern_matching_result = 13;
        }
        else if (equals(date, addDays(easterSunday, 49))) {
            pattern_matching_result = 14;
        }
        else if (equals(date, midsommarafton)) {
            pattern_matching_result = 15;
        }
        else if (equals(date, midsommardagen)) {
            pattern_matching_result = 16;
        }
        else if (equals(date, allaHelgonsDag)) {
            pattern_matching_result = 17;
        }
        else if (dayOfWeek(date) === 6) {
            pattern_matching_result = 18;
        }
        else if (dayOfWeek(date) === 0) {
            pattern_matching_result = 19;
        }
        else {
            pattern_matching_result = 20;
        }
    }
    else if (matchValue[0] === 12) {
        if (matchValue[1] === 24) {
            pattern_matching_result = 5;
        }
        else if (matchValue[1] === 25) {
            pattern_matching_result = 6;
        }
        else if (matchValue[1] === 26) {
            pattern_matching_result = 7;
        }
        else if (matchValue[1] === 31) {
            pattern_matching_result = 8;
        }
        else if (equals(date, addDays(easterSunday, -2))) {
            pattern_matching_result = 9;
        }
        else if (equals(date, addDays(easterSunday, -1))) {
            pattern_matching_result = 10;
        }
        else if (equals(date, easterSunday)) {
            pattern_matching_result = 11;
        }
        else if (equals(date, addDays(easterSunday, 1))) {
            pattern_matching_result = 12;
        }
        else if (equals(date, addDays(easterSunday, 39))) {
            pattern_matching_result = 13;
        }
        else if (equals(date, addDays(easterSunday, 49))) {
            pattern_matching_result = 14;
        }
        else if (equals(date, midsommarafton)) {
            pattern_matching_result = 15;
        }
        else if (equals(date, midsommardagen)) {
            pattern_matching_result = 16;
        }
        else if (equals(date, allaHelgonsDag)) {
            pattern_matching_result = 17;
        }
        else if (dayOfWeek(date) === 6) {
            pattern_matching_result = 18;
        }
        else if (dayOfWeek(date) === 0) {
            pattern_matching_result = 19;
        }
        else {
            pattern_matching_result = 20;
        }
    }
    else if (equals(date, addDays(easterSunday, -2))) {
        pattern_matching_result = 9;
    }
    else if (equals(date, addDays(easterSunday, -1))) {
        pattern_matching_result = 10;
    }
    else if (equals(date, easterSunday)) {
        pattern_matching_result = 11;
    }
    else if (equals(date, addDays(easterSunday, 1))) {
        pattern_matching_result = 12;
    }
    else if (equals(date, addDays(easterSunday, 39))) {
        pattern_matching_result = 13;
    }
    else if (equals(date, addDays(easterSunday, 49))) {
        pattern_matching_result = 14;
    }
    else if (equals(date, midsommarafton)) {
        pattern_matching_result = 15;
    }
    else if (equals(date, midsommardagen)) {
        pattern_matching_result = 16;
    }
    else if (equals(date, allaHelgonsDag)) {
        pattern_matching_result = 17;
    }
    else if (dayOfWeek(date) === 6) {
        pattern_matching_result = 18;
    }
    else if (dayOfWeek(date) === 0) {
        pattern_matching_result = 19;
    }
    else {
        pattern_matching_result = 20;
    }
    switch (pattern_matching_result) {
        case 0: {
            return new DayInfo(0, "Nyårsdagen");
        }
        case 1: {
            return new DayInfo(1, "Trettondagsafton");
        }
        case 2: {
            return new DayInfo(0, "Trettondedag jul");
        }
        case 3: {
            return new DayInfo(0, "Första maj");
        }
        case 4: {
            return new DayInfo(0, "Nationaldagen");
        }
        case 5: {
            return new DayInfo(1, "Julafton");
        }
        case 6: {
            return new DayInfo(0, "Juldagen");
        }
        case 7: {
            return new DayInfo(0, "Annandag jul");
        }
        case 8: {
            return new DayInfo(1, "Nyårsafton");
        }
        case 9: {
            return new DayInfo(0, "Långfredagen");
        }
        case 10: {
            return new DayInfo(1, "Påskafton");
        }
        case 11: {
            return new DayInfo(0, "Påskdagen");
        }
        case 12: {
            return new DayInfo(0, "Annandag påsk");
        }
        case 13: {
            return new DayInfo(0, "Kristi himmelfärdsdag");
        }
        case 14: {
            return new DayInfo(0, "Pingstdagen");
        }
        case 15: {
            return new DayInfo(1, "Midsommarafton");
        }
        case 16: {
            return new DayInfo(0, "Midsommardagen");
        }
        case 17: {
            return new DayInfo(0, "Alla helgons dag");
        }
        case 18: {
            return new DayInfo(2, "Lördag");
        }
        case 19: {
            return new DayInfo(2, "Söndag");
        }
        case 20: {
            return new DayInfo(3);
        }
    }
}

export function getDayInfo(country, date) {
    if (country.ThreeLetter.toLocaleUpperCase() === "SWE") {
        const matchValue_1 = SweHoliday_getSwedishDayInfo(date);
        switch (matchValue_1.tag) {
            case 1: {
                return matchValue_1.fields[0];
            }
            case 2: {
                return matchValue_1.fields[0];
            }
            case 3: {
                return void 0;
            }
            default: {
                return matchValue_1.fields[0];
            }
        }
    }
    else {
        return void 0;
    }
}

function renderDeviceTable(getTranslation, simsLoadState) {
    if (simsLoadState.tag === 1) {
        return react.createElement("div", {}, dotsLoading);
    }
    else if (simsLoadState.tag === 3) {
        const children_3 = [error(simsLoadState.fields[0].split(""))];
        return react.createElement("div", {}, ...children_3);
    }
    else if (simsLoadState.tag === 2) {
        if (simsLoadState.fields[0] != null) {
            const sim = simsLoadState.fields[0];
            const matchValue = [sim.Imei, sim.Brand, sim.Model, sim.Supports5G];
            let pattern_matching_result;
            if (matchValue[0] == null) {
                if (matchValue[1] == null) {
                    if (matchValue[2] == null) {
                        if (matchValue[3] == null) {
                            pattern_matching_result = 0;
                        }
                        else {
                            pattern_matching_result = 1;
                        }
                    }
                    else {
                        pattern_matching_result = 1;
                    }
                }
                else {
                    pattern_matching_result = 1;
                }
            }
            else {
                pattern_matching_result = 1;
            }
            switch (pattern_matching_result) {
                case 0: {
                    return react.createElement(react.Fragment, {});
                }
                case 1: {
                    const children_6 = [renderSideTable(getTranslation("Common.Device"), toList(delay(() => append((sim.Imei != null) ? singleton(ofArray(["IMEI", value_2(sim.Imei)])) : empty(), delay(() => append((sim.Brand != null) ? singleton(ofArray([getTranslation("CustomerContract.Invoicee.Subscriptions.Telecom.Brand"), value_2(sim.Brand)])) : empty(), delay(() => append((sim.Model != null) ? singleton(ofArray([getTranslation("CustomerContract.Invoicee.Subscriptions.Telecom.Model"), value_2(sim.Model)])) : empty(), delay(() => ((sim.Supports5G != null) ? singleton(toList(delay(() => append(singleton(getTranslation("CustomerContract.Invoicee.Subscriptions.Telecom.Supports5G")), delay(() => (value_2(sim.Supports5G) ? singleton(getTranslation("Common.Yes")) : singleton(getTranslation("Common.No")))))))) : empty()))))))))))];
                    return react.createElement("div", {
                        id: "device-table",
                        className: "fit-content mr-4",
                    }, ...children_6);
                }
            }
        }
        else {
            return warning(getTranslation("CustomerContract.Invoicee.Subscriptions.Telecom.MissingSim").split(""));
        }
    }
    else {
        return react.createElement(react.Fragment, {});
    }
}

function renderSimTable(getTranslation, simsLoadState) {
    if (simsLoadState.tag === 1) {
        return react.createElement("div", {}, dotsLoading);
    }
    else if (simsLoadState.tag === 3) {
        const children_4 = [error(simsLoadState.fields[0].split(""))];
        return react.createElement("div", {}, ...children_4);
    }
    else if (simsLoadState.tag === 2) {
        if (simsLoadState.fields[0] != null) {
            const sim = simsLoadState.fields[0];
            const children_6 = [renderSideTable("SIM", toList(delay(() => append(singleton(ofArray(["PIN", sim.Pin])), delay(() => append(singleton(ofArray(["PUK", sim.Puk])), delay(() => append(singleton(ofArray(["ICC", sim.Icc])), delay(() => append(singleton(ofArray(["IMSI", toString(sim.Imsi)])), delay(() => append(singleton(ofArray([getTranslation("CustomerContract.Invoicee.Subscriptions.Telecom.SimTypeCode"), sim.SimTypeCode])), delay(() => ((sim.PackageNumber != null) ? singleton(ofArray(["Nummersatt", value_2(sim.PackageNumber)])) : empty()))))))))))))))];
            return react.createElement("div", {
                id: "sims-table",
                className: "fit-content mr-4",
            }, ...children_6);
        }
        else {
            return warning(getTranslation("CustomerContract.Invoicee.Subscriptions.Telecom.MissingSim").split(""));
        }
    }
    else {
        const children = [info_1(getTranslation("CustomerContract.Invoicee.Subscriptions.Telecom.WaitingToLoadSims").split(""))];
        return react.createElement("div", {
            ["data-translation"]: "CustomerContract.Invoicee.Subscriptions.Telecom.WaitingToLoadSims",
        }, ...children);
    }
}

function renderHistoryTable(getTranslation, locale, nh) {
    const children = [renderSideTable(getTranslation("CustomerContract.Invoicee.Subscriptions.Telecom.History"), ofArray([ofArray([getTranslation("Common.Started"), defaultArg(map((dto) => toDisplayDate(locale.ILocale, dto), nh.ActiveFrom), "")]), ofArray([getTranslation("Common.Ends"), defaultArg(map((dto_1) => toDisplayDate(locale.ILocale, dto_1), nh.ActiveTo), "")]), ofArray(["ICC", optToStr(nh.Icc)]), ofArray(["IMSI", optToStr(nh.Imsi)])]))];
    return react.createElement("div", {
        className: "fit-content mb-4 mr-4",
    }, ...children);
}

function renderTrafficRedirects(locale, trLoadState) {
    if (trLoadState.tag === 1) {
        return dotsLoading;
    }
    else if (trLoadState.tag === 3) {
        return error(trLoadState.fields[0].split(""));
    }
    else if (trLoadState.tag === 2) {
        if (isEmpty(trLoadState.fields[0])) {
            return react.createElement(react.Fragment, {});
        }
        else {
            const children_4 = [react.createElement("h3", {}, "Traffic Redirects"), Pagination()(new PageinationProps$1((rows) => renderTable(ofArray(["From Number", "From Date", "To Date", "To Number", "Imsi", "SimType"]), map_1((tr) => ofArray([tr.FromNumber, DateTimeOffsetExtensions_toDateHHmmss(locale.ILocale, tr.FromDate), optToStr(map((date) => DateTimeOffsetExtensions_toDateHHmmss(locale.ILocale, date), tr.ToDate)), tr.ToNumber, optToStr(tr.Imsi), tr.SimType]), rows)), trLoadState.fields[0], 10, 0))];
            return react.createElement("div", {
                className: "mt-3 mb-3",
            }, ...children_4);
        }
    }
    else {
        return react.createElement(react.Fragment, {});
    }
}

export class CreatePortationModalProps extends Record {
    constructor(Locale, CountryCode, IsOpen, OnClose, OnSave) {
        super();
        this.Locale = Locale;
        this.CountryCode = CountryCode;
        this.IsOpen = IsOpen;
        this.OnClose = OnClose;
        this.OnSave = OnSave;
    }
}

export function CreatePortationModalProps$reflection() {
    return record_type("Containers.Telecom.View.CreatePortationModalProps", [], CreatePortationModalProps, () => [["Locale", Locale$reflection()], ["CountryCode", IsoCountryCode$reflection()], ["IsOpen", bool_type], ["OnClose", lambda_type(unit_type, unit_type)], ["OnSave", lambda_type(string_type, lambda_type(option_type(string_type), lambda_type(class_type("System.DateTime"), unit_type)))]]);
}

export const renderCreatePortationModal = FunctionComponent_Of_Z5A158BBF((props) => {
    const translationsLoadState = useSelector((state) => state.Model.Translations);
    const getTranslation = (key) => getTranslationFrom(translationsLoadState, key);
    const phoneNumberState = react.useState("");
    const orgNrState = react.useState("");
    const getDateState = (countryCode) => {
        let matchValue_1;
        let date;
        let copyOfStruct_1;
        let copyOfStruct = now_1();
        copyOfStruct_1 = addDays(copyOfStruct, 7);
        date = date_5(copyOfStruct_1);
        const time = (countryCode.ThreeLetter === "NOR") ? create_1(11, 0, 0) : create_1(3, 0, 0);
        return op_Addition((matchValue_1 = (dayOfWeek_1(date) | 0), (matchValue_1 === 0) ? addDays(date, 1) : ((matchValue_1 === 6) ? addDays(date, 2) : date)), time);
    };
    let dateState;
    const arg = getDateState(props.CountryCode);
    dateState = react.useState(arg);
    react.useEffect(() => {
        dateState[1](getDateState(props.CountryCode));
    }, [props.CountryCode]);
    let modalBodyHtml;
    const children_6 = toList(delay(() => {
        let inputRecord, LabelText;
        return append(singleton(render_1()((inputRecord = TextProps$1_GetDefault(), (LabelText = getTranslation("Common.PhoneNumber"), new TextProps$1(phoneNumberState[0], inputRecord.Type, inputRecord.Classes, (e) => {
            const arg_2 = Browser_Types_Event__Event_get_Value(e);
            phoneNumberState[1](arg_2);
        }, inputRecord.Disabled, LabelText, "create-portation-phone-number", inputRecord.ValidationFn, inputRecord.DynamicWidth, inputRecord.HTMLProps, (_arg) => {
            const arg_1 = correctPhoneNumber(props.CountryCode, phoneNumberState[0]);
            phoneNumberState[1](arg_1);
        }, inputRecord.OnFocus, inputRecord.AutoComplete, inputRecord.Name))))), delay(() => {
            let inputRecord_1, LabelText_1;
            return append(singleton(inputDate((inputRecord_1 = DateOptions_get_getDefault(), (LabelText_1 = getTranslation("CustomerContract.Invoicee.Subscriptions.PortationDate"), new DateOptions(ofArray([Id_3("create-portation-date"), EnableTimePicker(true), TimeTwentyFour(true), Value_2(dateState[0]), FormatDateBy((date_2) => DateTimeExtensions_toDateHHmm(props.Locale.ILocale, date_2)), Locale_1(props.Locale.FlatpickrLocale), OnChange_2((arg_3) => {
                dateState[1](arg_3);
            }), custom("onDayCreate", (selectedDates, str, fp, dayElement) => {
                const date_3 = dayElement.dateObj;
                const info = getDayInfo(props.CountryCode, create(year_1(date_3), month_3(date_3), day_2(date_3)));
                if (info == null) {
                }
                else {
                    const s = info;
                    dayElement.classList.add("unsuitablePortationDate");
                    dayElement.title = s;
                }
            }, false)]), LabelText_1, true, inputRecord_1.Disabled, inputRecord_1.OnClearClick))))), delay(() => {
                let x, matchValue_2, children;
                const specialDay = getDayInfo(props.CountryCode, (x = (dateState[0]), create(year_1(x), month_3(x), day_2(x))));
                return append((matchValue_2 = [props.CountryCode.ThreeLetter.toLocaleUpperCase(), specialDay], (matchValue_2[0] === "SWE") ? ((matchValue_2[1] != null) ? singleton((children = ["OBS: Valt datum är en " + matchValue_2[1]], react.createElement("p", {
                    className: "unsuitablePortationSelected",
                }, ...children))) : ((empty()))) : ((empty()))), delay(() => {
                    let portationDescriptionStr;
                    const infoText = getTranslation("CustomerContract.Invoicee.Subscriptions.PortationInfo");
                    const timeStr = toString_1(getDateState(props.CountryCode), "HH:mm");
                    portationDescriptionStr = toText(printf("%s %s."))(infoText)(timeStr);
                    return append(singleton(react.createElement("p", {
                        className: "portation__info",
                        ["data-translation"]: "CustomerContract.Invoicee.Subscriptions.PortationInfo",
                    }, portationDescriptionStr)), delay(() => {
                        let inputRecord_2, LabelText_2;
                        return append(singleton(render_1()((inputRecord_2 = TextProps$1_GetDefault(), (LabelText_2 = getTranslation("Common.OrgNrLong"), new TextProps$1(orgNrState[0], inputRecord_2.Type, inputRecord_2.Classes, (e_1) => {
                            const arg_6 = Browser_Types_Event__Event_get_Value(e_1);
                            orgNrState[1](arg_6);
                        }, inputRecord_2.Disabled, LabelText_2, "create-portation-orgnr", inputRecord_2.ValidationFn, inputRecord_2.DynamicWidth, inputRecord_2.HTMLProps, inputRecord_2.OnBlur, inputRecord_2.OnFocus, inputRecord_2.AutoComplete, inputRecord_2.Name))))), delay(() => {
                            let children_4;
                            return singleton((children_4 = [getTranslation("CustomerContract.Invoicee.Subscriptions.NumberInfo")], react.createElement("p", {
                                className: "portation__info",
                                ["data-translation"]: "CustomerContract.Invoicee.Subscriptions.NumberInfo",
                            }, ...children_4)));
                        }));
                    }));
                }));
            }));
        }));
    }));
    modalBodyHtml = react.createElement("div", {
        className: "create-portation-modal mb-3",
        id: "create-portation-modal",
    }, ...children_6);
    return render_2(props.IsOpen, new ModalSize(1), getTranslation("CustomerContract.Invoicee.Subscriptions.CreateInportation"), modalBodyHtml, getTranslation("Common.Cancel"), getTranslation("Common.Create"), (_arg_1) => {
        props.OnClose();
    }, (_arg_2) => {
        props.OnSave(phoneNumberState[0], strToOpt(orgNrState[0]), dateState[0]);
    });
}, "CreatePortationModal", uncurry(2, void 0), void 0, "renderCreatePortationModal", "E:\\w\\1835\\s\\FenixWebApp\\fable\\src\\Containers\\Telecom\\View.fs", 354);

class CreateActivationProps extends Record {
    constructor(CountryCode, Locale, ShowImsiInputField, SaveActivateNumber, CloseModalFn, ProductOpt, ContractTypeCodeOpt, PrefixSearchFn) {
        super();
        this.CountryCode = CountryCode;
        this.Locale = Locale;
        this.ShowImsiInputField = ShowImsiInputField;
        this.SaveActivateNumber = SaveActivateNumber;
        this.CloseModalFn = CloseModalFn;
        this.ProductOpt = ProductOpt;
        this.ContractTypeCodeOpt = ContractTypeCodeOpt;
        this.PrefixSearchFn = PrefixSearchFn;
    }
}

function CreateActivationProps$reflection() {
    return record_type("Containers.Telecom.View.CreateActivationProps", [], CreateActivationProps, () => [["CountryCode", IsoCountryCode$reflection()], ["Locale", Locale$reflection()], ["ShowImsiInputField", bool_type], ["SaveActivateNumber", lambda_type(string_type, lambda_type(class_type("System.DateTime"), lambda_type(option_type(class_type("System.DateTime")), lambda_type(option_type(string_type), class_type("Microsoft.FSharp.Control.FSharpAsync`1", [union_type("Microsoft.FSharp.Core.FSharpResult`2", [unit_type, string_type], FSharpResult$2, () => [[["ResultValue", unit_type]], [["ErrorValue", string_type]]])])))))], ["CloseModalFn", lambda_type(unit_type, unit_type)], ["ProductOpt", option_type(Product$reflection())], ["ContractTypeCodeOpt", option_type(string_type)], ["PrefixSearchFn", lambda_type(string_type, class_type("Microsoft.FSharp.Control.FSharpAsync`1", [union_type("Microsoft.FSharp.Core.FSharpResult`2", [array_type(string_type), string_type], FSharpResult$2, () => [[["ResultValue", array_type(string_type)]], [["ErrorValue", string_type]]])]))]]);
}

const renderCreateActivationModal = FunctionComponent_Of_Z5A158BBF((props) => {
    let children_1, children_7, inputRecord, LabelText, inputRecord_1, LabelText_1, inputRecord_2, LabelText_2, arg_11, arg_10;
    const translationsLoadState = useSelector((state) => state.Model.Translations);
    const getTranslation = (key) => getTranslationFrom(translationsLoadState, key);
    const activationDateState = react.useState(now_1());
    const endDateState = react.useState(void 0);
    const phoneNumberState = react.useState("");
    const iccOrImsiState = react.useState("");
    const saveState = react.useState(new SaveStatus_1(0));
    const noProvisioningMsgHtml = info_1(getTranslation("CustomerContract.Invoicee.Subscriptions.Telecom.NoProvisioning").split(""));
    let imsiRequirementMsgHtml;
    const matchValue = [props.ProductOpt, props.ShowImsiInputField];
    let pattern_matching_result, product;
    if (matchValue[0] != null) {
        if (matchValue[1]) {
            pattern_matching_result = 0;
            product = matchValue[0];
        }
        else {
            pattern_matching_result = 1;
        }
    }
    else {
        pattern_matching_result = 1;
    }
    switch (pattern_matching_result) {
        case 0: {
            let text;
            const arg_4 = getTranslation("CustomerContract.Invoicee.Subscriptions.Telecom.ImsiReq2");
            const arg_3 = ProductModule_toTranslation(getTranslation, product);
            const arg_2 = getTranslation("CustomerContract.Invoicee.Subscriptions.Telecom.ImsiReq1");
            text = toText(printf("%s \"%s\". %s."))(arg_2)(arg_3)(arg_4);
            let anchorHtml;
            const matchValue_1 = props.ContractTypeCodeOpt;
            if (matchValue_1 != null) {
                const contractTypeCode = matchValue_1;
                const href = toText(printf("/#/Contracts/ContractType/%s"))(contractTypeCode);
                const props_4 = [new HTMLAttr(65, stackClasses(ofArray(["d-flex", "align-items-center"]))), new HTMLAttr(94, href), new HTMLAttr(157, "_blank")];
                const children_3 = [(children_1 = [getTranslation("CustomerContract.Invoicee.Subscriptions.Telecom.ImsiReq3")], react.createElement("span", {
                    className: "mr-1",
                }, ...children_1)), getMaterialIconBySize("open_in_new", new Size(1))];
                anchorHtml = react.createElement("a", keyValueList(props_4, 1), ...children_3);
            }
            else {
                anchorHtml = react.createElement(react.Fragment, {});
            }
            imsiRequirementMsgHtml = customMessage((children_7 = [react.createElement("div", {}, text), anchorHtml], react.createElement("div", {}, ...children_7)), new MessageKind(0));
            break;
        }
        case 1: {
            imsiRequirementMsgHtml = react.createElement(react.Fragment, {});
            break;
        }
    }
    const imsiHtml = props.ShowImsiInputField ? render_3()(new SearchSuggestionProps$1(props.PrefixSearchFn, iccOrImsiState[0], (arg_6) => {
        iccOrImsiState[1](arg_6);
    }, "IMSI", "activation-modal-imsi-input", (str) => isImsiOrIcc(getTranslation, str), 250)) : react.createElement(react.Fragment, {});
    const numberHtml = render_1()((inputRecord = TextProps$1_GetDefault(), (LabelText = getTranslation("Common.Number"), new TextProps$1(phoneNumberState[0], inputRecord.Type, inputRecord.Classes, (e) => {
        phoneNumberState[1](Browser_Types_Event__Event_get_Value(e));
    }, inputRecord.Disabled, LabelText, "activation-modal-number-input", inputRecord.ValidationFn, inputRecord.DynamicWidth, inputRecord.HTMLProps, (_arg_1) => {
        const arg_7 = correctPhoneNumber(props.CountryCode, phoneNumberState[0]);
        phoneNumberState[1](arg_7);
    }, inputRecord.OnFocus, inputRecord.AutoComplete, inputRecord.Name))));
    const activationDateHtml = inputDate((inputRecord_1 = DateOptions_get_getDefault(), (LabelText_1 = getTranslation("CustomerContract.Invoicee.Subscriptions.Telecom.ActivationTime"), new DateOptions(ofArray([Placeholder(getTranslation("Common.Choose")), OnChange_2((arg_8) => {
        activationDateState[1](arg_8);
    }), Id_3("activation-start-time-picker"), FormatDateBy((date) => DateTimeExtensions_toDateHHmm(props.Locale.ILocale, date)), Locale_1(props.Locale.FlatpickrLocale), EnableTimePicker(true), TimeTwentyFour(true), Value_2(activationDateState[0])]), LabelText_1, true, inputRecord_1.Disabled, inputRecord_1.OnClearClick))));
    const endDateHtml = inputDate((inputRecord_2 = DateOptions_get_getDefault(), (LabelText_2 = getTranslation("CustomerContract.Invoicee.Subscriptions.Telecom.EndTime"), new DateOptions(toList(delay(() => append(singleton(Placeholder(getTranslation("Common.Choose"))), delay(() => append(singleton(Flatpickr_OnChangeOption((arg_9) => {
        endDateState[1](arg_9);
    })), delay(() => append(singleton(Placeholder(getTranslation("Common.Optional"))), delay(() => append(singleton(Id_3("activation-end-time-picker")), delay(() => append(singleton(FormatDateBy((date_1) => DateTimeExtensions_toDateHHmm(props.Locale.ILocale, date_1))), delay(() => append(singleton(Locale_1(props.Locale.FlatpickrLocale)), delay(() => append(singleton(EnableTimePicker(true)), delay(() => append(singleton(TimeTwentyFour(true)), delay(() => (((endDateState[0]) != null) ? singleton(Value_2(value_2(endDateState[0]))) : empty()))))))))))))))))))), LabelText_2, true, inputRecord_2.Disabled, inputRecord_2.OnClearClick))));
    const modalBodyHtml = react.createElement("div", {
        className: "create-activation-modal",
    }, imsiHtml, numberHtml, activationDateHtml, endDateHtml, noProvisioningMsgHtml, imsiRequirementMsgHtml);
    if ((saveState[0]).tag === 0) {
        let isAcceptDisabled;
        if (props.ShowImsiInputField) {
            const matchValue_5 = isImsiOrIcc(getTranslation, iccOrImsiState[0]);
            isAcceptDisabled = (matchValue_5.tag === 1);
        }
        else {
            isAcceptDisabled = false;
        }
        const cancelButtonProps = new ButtonProps(getTranslation("Common.Cancel"), defaultProps.Content, (_arg_2) => {
            props.CloseModalFn();
        }, defaultProps.Disabled, "create-activation-modal-cancel-btn", defaultProps.SaveStatus, defaultProps.HTMLProps, defaultProps.ExtraClasses, defaultProps.Icon);
        const acceptButtonProps = new ButtonProps(getTranslation("Common.Create"), defaultProps.Content, (_arg_3) => {
            const iccOrImsiOpt = iccOrImsiState[0];
            const endDateOpt = endDateState[0];
            const activationDate = activationDateState[0];
            const number = phoneNumberState[0];
            saveState[1](new SaveStatus_1(1));
            startImmediate(singleton_1.Delay(() => singleton_1.Bind(props.SaveActivateNumber(number, activationDate, endDateOpt, iccOrImsiOpt), (_arg) => {
                const result = _arg;
                const arg = (result.tag === 0) ? (new SaveStatus_1(2)) : (new SaveStatus_1(3, result.fields[0]));
                saveState[1](arg);
                return singleton_1.Zero();
            })));
        }, isAcceptDisabled, "create-activation-modal-accept-btn", defaultProps.SaveStatus, defaultProps.HTMLProps, defaultProps.ExtraClasses, defaultProps.Icon);
        return renderWithButtonProps(true, new ModalSize(1), getTranslation("CustomerContract.Invoicee.Subscriptions.CreateActivation"), modalBodyHtml, cancelButtonProps, acceptButtonProps);
    }
    else {
        return render_4(true, new ModalSize(0), (arg_11 = getTranslation("CustomerContract.Invoicee.Activation"), (arg_10 = getTranslation("Common.Creating"), toText(printf("%s %s"))(arg_10)(arg_11))), singleton_2([getTranslation("Common.Creating") + "...", saveState[0]]), getTranslation("Common.Ok"), (_arg_4) => {
            props.CloseModalFn();
        });
    }
}, "CreateActivationModal", uncurry(2, void 0), void 0, "renderCreateActivationModal", "E:\\w\\1835\\s\\FenixWebApp\\fable\\src\\Containers\\Telecom\\View.fs", 569);

export class DeactivateNumberButtonProps extends Record {
    constructor(NumberFrom, Locale, OnSave, SaveStatus, OnConfirmSaveStatus) {
        super();
        this.NumberFrom = NumberFrom;
        this.Locale = Locale;
        this.OnSave = OnSave;
        this.SaveStatus = SaveStatus;
        this.OnConfirmSaveStatus = OnConfirmSaveStatus;
    }
}

export function DeactivateNumberButtonProps$reflection() {
    return record_type("Containers.Telecom.View.DeactivateNumberButtonProps", [], DeactivateNumberButtonProps, () => [["NumberFrom", string_type], ["Locale", Locale$reflection()], ["OnSave", lambda_type(class_type("System.DateTime"), unit_type)], ["SaveStatus", SaveStatus$reflection()], ["OnConfirmSaveStatus", lambda_type(unit_type, unit_type)]]);
}

const renderDeactivateNumberButton = FunctionComponent_Of_Z5A158BBF((props) => {
    let children_4, children, arg, inputRecord, LabelText, inputRecord_1;
    const translationsLoadState = useSelector((state) => state.Model.Translations);
    const getTranslation = (key) => getTranslationFrom(translationsLoadState, key);
    const isModalOpenState = react.useState(false);
    const endDateState = react.useState(void 0);
    const resetStates = () => {
        isModalOpenState[1](false);
        endDateState[1](void 0);
    };
    let modalHtml;
    let bodyHtml;
    const children_6 = [(children_4 = [(children = [(arg = getTranslation("Common.Number"), toText(printf("%s: "))(arg))], react.createElement("span", {
        className: "font-weight-bold",
    }, ...children)), react.createElement("span", {
        className: "ml-2",
    }, props.NumberFrom)], react.createElement("div", {
        className: "d-flex",
    }, ...children_4)), inputDate((inputRecord = DateOptions_get_getDefault(), (LabelText = getTranslation("Common.ActiveTo"), new DateOptions(toList(delay(() => append(singleton(Id_3("active-to-input")), delay(() => append(singleton(OnChange_2((date) => {
        endDateState[1](date);
    })), delay(() => append(((endDateState[0]) != null) ? singleton(Value_2(value_2(endDateState[0]))) : empty(), delay(() => append(singleton(Locale_1(props.Locale.FlatpickrLocale)), delay(() => append(singleton(TimeTwentyFour(true)), delay(() => append(singleton(EnableTimePicker(true)), delay(() => singleton(FormatDateBy((date_1) => DateTimeExtensions_toDateHHmm(props.Locale.ILocale, date_1))))))))))))))))), LabelText, inputRecord.ShowIcon, inputRecord.Disabled, inputRecord.OnClearClick))))];
    bodyHtml = react.createElement("div", {
        className: "telecom-container color-black",
    }, ...children_6);
    modalHtml = ((props.SaveStatus.tag === 0) ? render_2(isModalOpenState[0], new ModalSize(0), getTranslation("Common.DeactivateNumber"), bodyHtml, getTranslation("Common.Cancel"), getTranslation("Common.Save"), (_arg) => {
        resetStates();
        isModalOpenState[1](false);
    }, (_arg_1) => {
        if ((endDateState[0]) != null) {
            props.OnSave(value_2(endDateState[0]));
        }
    }) : render_4(true, new ModalSize(0), getTranslation("Common.DeactivateNumber"), singleton_2([getTranslation("Common.Saving") + "...", props.SaveStatus]), getTranslation("Common.Ok"), (_arg_2) => {
        props.OnConfirmSaveStatus();
        resetStates();
        isModalOpenState[1](false);
    }));
    const children_8 = [secondary((inputRecord_1 = ButtonProps_get_getDefault(), new ButtonProps(getTranslation("Common.DeactivateNumber"), inputRecord_1.Content, (_arg_3) => {
        isModalOpenState[1](true);
    }, inputRecord_1.Disabled, "number-edit-btn", inputRecord_1.SaveStatus, inputRecord_1.HTMLProps, inputRecord_1.ExtraClasses, inputRecord_1.Icon))), modalHtml];
    return react.createElement("div", {}, ...children_8);
}, "DeactivateNumberButton", Helpers_equalsButFunctions, void 0, "renderDeactivateNumberButton", "E:\\w\\1835\\s\\FenixWebApp\\fable\\src\\Containers\\Telecom\\View.fs", 655);

export class Editability extends Union {
    constructor(tag, ...fields) {
        super();
        this.tag = (tag | 0);
        this.fields = fields;
    }
    cases() {
        return ["EnableDateFrom", "EnableDateTo", "EnableBoth"];
    }
}

export function Editability$reflection() {
    return union_type("Containers.Telecom.View.Editability", [], Editability, () => [[], [], []]);
}

export function Editability_GetEditability(currentIndex, firstIndex, lastIndex) {
    if ((currentIndex === firstIndex) && (currentIndex === lastIndex)) {
        return new Editability(2);
    }
    else if (currentIndex === firstIndex) {
        return new Editability(1);
    }
    else {
        return new Editability(0);
    }
}

export class NumberRegisterModificationProps extends Record {
    constructor(NumberHistory, SaveFn, SaveStatus, ResetSaveStatus, Editability) {
        super();
        this.NumberHistory = NumberHistory;
        this.SaveFn = SaveFn;
        this.SaveStatus = SaveStatus;
        this.ResetSaveStatus = ResetSaveStatus;
        this.Editability = Editability;
    }
}

export function NumberRegisterModificationProps$reflection() {
    return record_type("Containers.Telecom.View.NumberRegisterModificationProps", [], NumberRegisterModificationProps, () => [["NumberHistory", NumberHistory$reflection()], ["SaveFn", lambda_type(tuple_type(string_type, NumberRegisterModificationDTO$reflection()), unit_type)], ["SaveStatus", SaveStatus$reflection()], ["ResetSaveStatus", lambda_type(unit_type, unit_type)], ["Editability", Editability$reflection()]]);
}

export const renderNumberRegisterModification = FunctionComponent_Of_Z5A158BBF((props) => {
    let inputRecord, LabelText, Disabled, inputRecord_1, LabelText_1, Disabled_1, arg_6, arg_5, children_7;
    const translationsLoadState = useSelector((state) => state.Model.Translations);
    const getTranslation = (key) => getTranslationFrom(translationsLoadState, key);
    const isModalOpenState = react.useState(false);
    const activeFromState = react.useState(map((d) => fromDateTimeOffset(d, 0), props.NumberHistory.ActiveFrom));
    const activeToState = react.useState(map((d_1) => fromDateTimeOffset(d_1, 0), props.NumberHistory.ActiveTo));
    const resetModalState = () => {
        props.ResetSaveStatus();
        activeFromState[1](map((d_2) => fromDateTimeOffset(d_2, 0), props.NumberHistory.ActiveFrom));
        activeToState[1](map((d_3) => fromDateTimeOffset(d_3, 0), props.NumberHistory.ActiveTo));
    };
    react.useEffect(() => {
        if (props.SaveStatus.tag === 0) {
            resetModalState();
        }
    }, [props.NumberHistory]);
    let modalHtml;
    let bodyHtml;
    let saveFailedMsgHtml;
    const matchValue_1 = props.SaveStatus;
    saveFailedMsgHtml = ((matchValue_1.tag === 3) ? error(matchValue_1.fields[0].split("")) : react.createElement(react.Fragment, {}));
    let numberHtml;
    if (props.NumberHistory.NumberFrom === props.NumberHistory.NumberTo) {
        let numberStr;
        const arg = getTranslation("Common.Number");
        numberStr = toText(printf("%s: %s"))(arg)(props.NumberHistory.NumberFrom);
        numberHtml = react.createElement("div", {}, numberStr);
    }
    else {
        let numberStr_1;
        const arg_2 = getTranslation("Common.Number");
        numberStr_1 = toText(printf("%s: %s - %s"))(arg_2)(props.NumberHistory.NumberFrom)(props.NumberHistory.NumberTo);
        numberHtml = react.createElement("div", {}, numberStr_1);
    }
    let activeFromHtml;
    const maxDateOpt = map((d_4) => fromDateTimeOffset(d_4, 0), props.NumberHistory.ActiveTo);
    const minDate = minValue();
    activeFromHtml = inputDate((inputRecord = DateOptions_get_getDefault(), (LabelText = getTranslation("Common.ActiveFrom"), (Disabled = equals_1(props.Editability, new Editability(1)), new DateOptions(toList(delay(() => append((maxDateOpt != null) ? singleton(EnableRanges(singleton_2([minDate, value_2(maxDateOpt)]))) : empty(), delay(() => append(singleton(EnableTimePicker(true)), delay(() => append(singleton(TimeTwentyFour(true)), delay(() => append(((activeFromState[0]) != null) ? singleton(Value_2(value_2(activeFromState[0]))) : empty(), delay(() => singleton(OnChange_2((date) => {
        activeFromState[1](date);
    })))))))))))), LabelText, true, Disabled, inputRecord.OnClearClick)))));
    let activeToHtml;
    const minDateOpt = map((d_5) => {
        let copyOfStruct = fromDateTimeOffset(d_5, 0);
        return addDays(copyOfStruct, -1);
    }, props.NumberHistory.ActiveFrom);
    const maxDate = maxValue();
    activeToHtml = inputDate((inputRecord_1 = DateOptions_get_getDefault(), (LabelText_1 = getTranslation("Common.ActiveTo"), (Disabled_1 = equals_1(props.Editability, new Editability(0)), new DateOptions(toList(delay(() => append((minDateOpt != null) ? singleton(EnableRanges(singleton_2([value_2(minDateOpt), maxDate]))) : empty(), delay(() => append(singleton(EnableTimePicker(true)), delay(() => append(singleton(TimeTwentyFour(true)), delay(() => append(((activeToState[0]) != null) ? singleton(Value_2(value_2(activeToState[0]))) : empty(), delay(() => singleton(Flatpickr_OnChangeOption((dateOpt) => {
        activeToState[1](dateOpt);
    })))))))))))), LabelText_1, true, Disabled_1, inputRecord_1.OnClearClick)))));
    bodyHtml = react.createElement("div", {
        className: "register-modification__modal",
    }, numberHtml, activeFromHtml, activeToHtml, saveFailedMsgHtml);
    let cancelButtonProps;
    const inputRecord_2 = ButtonProps_get_getDefault();
    cancelButtonProps = (new ButtonProps(getTranslation("Common.Cancel"), inputRecord_2.Content, (_arg) => {
        isModalOpenState[1](false);
        resetModalState();
    }, inputRecord_2.Disabled, inputRecord_2.Id, inputRecord_2.SaveStatus, inputRecord_2.HTMLProps, inputRecord_2.ExtraClasses, inputRecord_2.Icon));
    let acceptButtonProps;
    const inputRecord_3 = ButtonProps_get_getDefault();
    acceptButtonProps = (new ButtonProps(getTranslation("Common.Save"), inputRecord_3.Content, (_arg_1) => {
        const matchValue_2 = [activeFromState[0], props.NumberHistory.ActiveFrom];
        let pattern_matching_result, activeFrom, originalActiveFrom;
        if (matchValue_2[0] != null) {
            if (matchValue_2[1] != null) {
                pattern_matching_result = 0;
                activeFrom = matchValue_2[0];
                originalActiveFrom = matchValue_2[1];
            }
            else {
                pattern_matching_result = 1;
            }
        }
        else {
            pattern_matching_result = 1;
        }
        switch (pattern_matching_result) {
            case 0: {
                props.SaveFn([props.NumberHistory.NumberFrom, new NumberRegisterModificationDTO(DateTimeExtensions_yyyy_MM_ddTHH_mm_ssZ(activeFrom), map(DateTimeExtensions_yyyy_MM_ddTHH_mm_ssZ, activeToState[0]), DateTimeOffsetExtensions_yyyy_MM_ddTHH_mm_ss_fffZ(originalActiveFrom))]);
                break;
            }
            case 1: {
                break;
            }
        }
    }, inputRecord_3.Disabled, inputRecord_3.Id, props.SaveStatus, inputRecord_3.HTMLProps, inputRecord_3.ExtraClasses, inputRecord_3.Icon));
    modalHtml = renderAsModalThenSaveState(isModalOpenState[0], new ModalSize(1), getTranslation("CustomerContract.Invoicee.Subscriptions.Telecom.ModifyNumberRegistry"), bodyHtml, cancelButtonProps, acceptButtonProps, getTranslation("Common.Close"), (_arg_2) => {
        isModalOpenState[1](false);
        resetModalState();
    }, singleton_2([(arg_6 = getTranslation("Common.Number"), (arg_5 = getTranslation("Common.Saving"), toText(printf("%s %s"))(arg_5)(arg_6))), props.SaveStatus]));
    const children_9 = [(children_7 = [getMaterialIcon("edit")], react.createElement("div", {
        onClick: (_arg_3) => {
            isModalOpenState[1](true);
        },
        className: "register-modification__pen",
    }, ...children_7)), modalHtml];
    return react.createElement("div", {
        className: "register-modification",
    }, ...children_9);
}, "NumberRegisterModification", uncurry(2, void 0), void 0, "renderNumberRegisterModification", "E:\\w\\1835\\s\\FenixWebApp\\fable\\src\\Containers\\Telecom\\View.fs", 822);

export class CreatePortationProps extends Record {
    constructor(IsMobile, IsVoIP, NetworkContractNr, SaveStatus, Locale, CountryCode, ClientNr, ContractNr, IsTab, UsesPortation, SaveCreateInportationFn, ClearErrorMessageFn) {
        super();
        this.IsMobile = IsMobile;
        this.IsVoIP = IsVoIP;
        this.NetworkContractNr = NetworkContractNr;
        this.SaveStatus = SaveStatus;
        this.Locale = Locale;
        this.CountryCode = CountryCode;
        this.ClientNr = (ClientNr | 0);
        this.ContractNr = (ContractNr | 0);
        this.IsTab = IsTab;
        this.UsesPortation = UsesPortation;
        this.SaveCreateInportationFn = SaveCreateInportationFn;
        this.ClearErrorMessageFn = ClearErrorMessageFn;
    }
}

export function CreatePortationProps$reflection() {
    return record_type("Containers.Telecom.View.CreatePortationProps", [], CreatePortationProps, () => [["IsMobile", bool_type], ["IsVoIP", bool_type], ["NetworkContractNr", option_type(int32_type)], ["SaveStatus", SaveStatus$reflection()], ["Locale", Locale$reflection()], ["CountryCode", IsoCountryCode$reflection()], ["ClientNr", int32_type], ["ContractNr", int32_type], ["IsTab", bool_type], ["UsesPortation", bool_type], ["SaveCreateInportationFn", lambda_type(tuple_type(string_type, option_type(string_type), class_type("System.DateTime")), unit_type)], ["ClearErrorMessageFn", lambda_type(unit_type, unit_type)]]);
}

const renderCreatePortation = FunctionComponent_Of_Z5A158BBF((props) => {
    const translationsLoadState = useSelector((state) => state.Model.Translations);
    const getTranslation = (key) => getTranslationFrom(translationsLoadState, key);
    const isModalOpenState = react.useState(new LoadState$2(0));
    const reduxDispatch = useDispatch();
    let createPortationButtonHtml;
    const matchValue = (((props.IsMobile ? true : props.IsVoIP) && (props.NetworkContractNr != null)) && props.UsesPortation) ? true : props.IsTab;
    createPortationButtonHtml = (matchValue ? wrappedButton(new ButtonKind(0), new ButtonProps(getTranslation("CustomerContract.Invoicee.Subscriptions.CreateInportation"), defaultProps.Content, (_arg) => {
        isModalOpenState[1](new LoadState$2(1));
        const onError = (errorMsg) => {
            reduxDispatch(error_1(errorMsg));
            isModalOpenState[1](new LoadState$2(3, errorMsg));
        };
        const _arg_1 = ValidatedUrlModule_create(new UrlKind(0, toText(printf("Telecom/Portation/%i/%i/CanCreatePortation"))(props.ClientNr)(props.ContractNr)));
        if (_arg_1.tag === 1) {
            onError("ValidateUrl: " + _arg_1.fields[0]);
        }
        else {
            startImmediate(singleton_1.Delay(() => {
                let parseFn, arg_2;
                return singleton_1.Bind((parseFn = ((arg_2 = defaultArg(new CaseStrategy(0), new CaseStrategy(0)), (arg_1_1) => {
                    const str = arg_1_1;
                    return equals_2(bool_type, string_type) ? (new FSharpResult$2(0, str)) : fromString(uncurry(2, Auto_generateBoxedDecoder_79988AEF(bool_type, arg_2, Http_get_ExtraCoders().Value)), str);
                })), singleton_1.Delay(() => singleton_1.Bind(Http_send(addClientReference(Http_withCredentials(true, Http_method(new HttpMethod(0), Http_request(ValidatedUrlModule_value(_arg_1.fields[0])))))), (_arg_2) => {
                    let response_1;
                    return singleton_1.Return((response_1 = _arg_2, (response_1.statusCode === 200) ? (equals_2(bool_type, string_type) ? (new FSharpResult$2(0, response_1.responseText)) : parseFn(response_1.responseText)) : (new FSharpResult$2(1, response_1.responseText))));
                }))), (_arg_1_1) => {
                    const _arg_2_1 = _arg_1_1;
                    if (_arg_2_1.tag === 1) {
                        onError("GET: " + _arg_2_1.fields[0]);
                    }
                    else if (_arg_2_1.fields[0]) {
                        isModalOpenState[1](new LoadState$2(2, void 0));
                    }
                    else {
                        reduxDispatch(warning_1(getTranslation("CustomerContract.Invoicee.Subscriptions.CreateInportation.CreatePortationNotAllowed")));
                        isModalOpenState[1](new LoadState$2(0));
                    }
                    return singleton_1.Zero();
                });
            }));
        }
    }, defaultProps.Disabled, "open-create-portation-modal-btn", ((isModalOpenState[0]).tag === 1) ? (new SaveStatus_1(1)) : props.SaveStatus, defaultProps.HTMLProps, defaultProps.ExtraClasses, defaultProps.Icon)) : react.createElement(react.Fragment, {}));
    const createPortationModalHtml = renderCreatePortationModal(new CreatePortationModalProps(props.Locale, props.CountryCode, (isModalOpenState[0]).tag === 2, () => {
        isModalOpenState[1](new LoadState$2(0));
    }, (number, orgNr, date) => {
        props.SaveCreateInportationFn([number, orgNr, date]);
        isModalOpenState[1](new LoadState$2(0));
    }));
    let portationErrorModalHtml;
    const matchValue_5 = props.SaveStatus;
    switch (matchValue_5.tag) {
        case 1:
        case 2: {
            portationErrorModalHtml = react.createElement(react.Fragment, {});
            break;
        }
        case 3: {
            portationErrorModalHtml = modal(true, render_5("Error Message", react.createElement("div", {}, matchValue_5.fields[0]), new MessageType(2), "Ok", (_arg_3) => {
                props.ClearErrorMessageFn();
            }));
            break;
        }
        default: {
            portationErrorModalHtml = react.createElement(react.Fragment, {});
        }
    }
    return react.createElement(react.Fragment, {}, createPortationButtonHtml, createPortationModalHtml, portationErrorModalHtml);
}, "CreatePortation", uncurry(2, void 0), void 0, "renderCreatePortation", "E:\\w\\1835\\s\\FenixWebApp\\fable\\src\\Containers\\Telecom\\View.fs", 925);

class RenderTelecomProps extends Record {
    constructor(ContractNr, GlobalDependencies, Contracts, ContractTypes, NumberHistory, SelectedNumberHistoryIndex, Sim, TrafficRedirects, CreatePortationSaveStatus, ShowMoreInfo, DeactivateNumberModal, NumberRegisterModificationSaveStatus, NetworkIntegrationNr, Orders, SelectNumberHistoryIndexFn, ReloadOrdersFn, SaveCreateInportationFn, ClearErrorMessageFn, LoadNumberHistoryFn, ShowMoreInfoFn, SaveDeactivateNumberFn, DeactivateNumberConfirmSaveStatusFn, SaveNumberRegisterModificationFn, ResetNumberRegisteredModificationFn, UpdateNetworkStatusFn) {
        super();
        this.ContractNr = (ContractNr | 0);
        this.GlobalDependencies = GlobalDependencies;
        this.Contracts = Contracts;
        this.ContractTypes = ContractTypes;
        this.NumberHistory = NumberHistory;
        this.SelectedNumberHistoryIndex = SelectedNumberHistoryIndex;
        this.Sim = Sim;
        this.TrafficRedirects = TrafficRedirects;
        this.CreatePortationSaveStatus = CreatePortationSaveStatus;
        this.ShowMoreInfo = ShowMoreInfo;
        this.DeactivateNumberModal = DeactivateNumberModal;
        this.NumberRegisterModificationSaveStatus = NumberRegisterModificationSaveStatus;
        this.NetworkIntegrationNr = NetworkIntegrationNr;
        this.Orders = Orders;
        this.SelectNumberHistoryIndexFn = SelectNumberHistoryIndexFn;
        this.ReloadOrdersFn = ReloadOrdersFn;
        this.SaveCreateInportationFn = SaveCreateInportationFn;
        this.ClearErrorMessageFn = ClearErrorMessageFn;
        this.LoadNumberHistoryFn = LoadNumberHistoryFn;
        this.ShowMoreInfoFn = ShowMoreInfoFn;
        this.SaveDeactivateNumberFn = SaveDeactivateNumberFn;
        this.DeactivateNumberConfirmSaveStatusFn = DeactivateNumberConfirmSaveStatusFn;
        this.SaveNumberRegisterModificationFn = SaveNumberRegisterModificationFn;
        this.ResetNumberRegisteredModificationFn = ResetNumberRegisteredModificationFn;
        this.UpdateNetworkStatusFn = UpdateNetworkStatusFn;
    }
}

function RenderTelecomProps$reflection() {
    return record_type("Containers.Telecom.View.RenderTelecomProps", [], RenderTelecomProps, () => [["ContractNr", int32_type], ["GlobalDependencies", GlobalDependencies$reflection()], ["Contracts", class_type("Microsoft.FSharp.Collections.FSharpMap`2", [int32_type, Contract$reflection()])], ["ContractTypes", class_type("Microsoft.FSharp.Collections.FSharpMap`2", [string_type, ContractType$reflection()])], ["NumberHistory", LoadState$2$reflection(list_type(NumberHistory$reflection()), string_type)], ["SelectedNumberHistoryIndex", option_type(int32_type)], ["Sim", LoadState$2$reflection(option_type(Sim$reflection()), string_type)], ["TrafficRedirects", LoadState$2$reflection(list_type(TrafficRedirect$reflection()), string_type)], ["CreatePortationSaveStatus", SaveStatus$reflection()], ["ShowMoreInfo", bool_type], ["DeactivateNumberModal", DeactivateNumberModal$reflection()], ["NumberRegisterModificationSaveStatus", SaveStatus$reflection()], ["NetworkIntegrationNr", LoadState$2$reflection(option_type(int32_type), string_type)], ["Orders", list_type(OrderDTO$reflection())], ["SelectNumberHistoryIndexFn", lambda_type(int32_type, unit_type)], ["ReloadOrdersFn", lambda_type(unit_type, unit_type)], ["SaveCreateInportationFn", lambda_type(tuple_type(string_type, option_type(string_type), class_type("System.DateTime")), unit_type)], ["ClearErrorMessageFn", lambda_type(unit_type, unit_type)], ["LoadNumberHistoryFn", lambda_type(unit_type, unit_type)], ["ShowMoreInfoFn", lambda_type(bool_type, unit_type)], ["SaveDeactivateNumberFn", lambda_type(class_type("System.DateTime"), unit_type)], ["DeactivateNumberConfirmSaveStatusFn", lambda_type(unit_type, unit_type)], ["SaveNumberRegisterModificationFn", lambda_type(tuple_type(string_type, NumberRegisterModificationDTO$reflection()), unit_type)], ["ResetNumberRegisteredModificationFn", lambda_type(unit_type, unit_type)], ["UpdateNetworkStatusFn", lambda_type(string_type, unit_type)]]);
}

const renderTelecom = FunctionComponent_Of_Z5A158BBF((props) => {
    let inputRecord, matchValue_15, currentNumberHistory, numberHistoryIndex, numberSpecificHistory, matchValue_16, firstIndex_1, lastIndex_1, children_22;
    const translationsLoadState = useSelector((state) => state.Model.Translations);
    const getTranslation = (key) => getTranslationFrom(translationsLoadState, key);
    const createActivationModalIsOpenState = react.useState(false);
    const networkContractNr = getNetworkContractNr(props.ContractNr, props.Contracts, props.ContractTypes);
    const selectedNumberHistoryOpt = react.useMemo(() => getSelectedNumberHistory(props.SelectedNumberHistoryIndex, props.NumberHistory), [props.NumberHistory, props.SelectedNumberHistoryIndex]);
    const matchValue = props.NumberHistory;
    switch (matchValue.tag) {
        case 1: {
            return dotsLoading;
        }
        case 3: {
            return error(matchValue.fields[0].split(""));
        }
        case 2: {
            const numberHistories = matchValue.fields[0];
            const productTypeOpt = getProductType(props.Contracts, props.ContractTypes, props.ContractNr);
            let usesProvisioningViaSvea;
            const matchValue_1 = props.NetworkIntegrationNr;
            usesProvisioningViaSvea = ((matchValue_1.tag === 2) && usesProvisioningViaSvea_1(matchValue_1.fields[0]));
            let patternInput;
            if (productTypeOpt != null) {
                const productType = productTypeOpt;
                patternInput = [equals_1(productType, new Product(2)), equals_1(productType, new Product(1)), equals_1(productType, new Product(0)), equals_1(productType, new Product(3))];
            }
            else {
                patternInput = [false, false, false, false];
            }
            const isVoIP = patternInput[0];
            const isTab = patternInput[1];
            const isMobileBroadband = patternInput[3];
            const isMobile = patternInput[2];
            const locale = Locale_get_FromSelectedLanguage()(props.GlobalDependencies.SelectedLanguage);
            const noNumberHistoryMsgHtml = isEmpty(numberHistories) ? info_1((getTranslation("CustomerContract.Invoicee.Subscriptions.Telecom.NoHistoryFound") + ".").split("")) : react.createElement(react.Fragment, {});
            const numberMenuHtml = (length(numberHistories) === 0) ? (void 0) : renderNumberMenu(new NumberMenuProps(props.SelectedNumberHistoryIndex, numberHistories, locale, props.SelectNumberHistoryIndexFn));
            let orderSectionHtml;
            const matchValue_3 = ((isMobile ? true : isMobileBroadband) && (networkContractNr != null)) && usesProvisioningViaSvea;
            if (matchValue_3) {
                const matchValue_4 = props.NumberHistory;
                switch (matchValue_4.tag) {
                    case 1: {
                        orderSectionHtml = dotsLoading;
                        break;
                    }
                    case 3: {
                        orderSectionHtml = error(matchValue_4.fields[0].split(""));
                        break;
                    }
                    case 2: {
                        orderSectionHtml = view_1(new TelecomOrderProps(props.GlobalDependencies, props.ContractNr, networkContractNr, map((x) => x.NumberFrom, selectedNumberHistoryOpt), props.ReloadOrdersFn));
                        break;
                    }
                    default: {
                        orderSectionHtml = react.createElement(react.Fragment, {});
                    }
                }
            }
            else {
                orderSectionHtml = react.createElement(react.Fragment, {});
            }
            const createPortationHtml = renderCreatePortation(new CreatePortationProps(isMobile, isVoIP, networkContractNr, props.CreatePortationSaveStatus, locale, props.GlobalDependencies.CountryCode, props.GlobalDependencies.ClientNr, props.ContractNr, isTab, props.GlobalDependencies.ClientConfig.TelecomUsePortation, props.SaveCreateInportationFn, props.ClearErrorMessageFn));
            const trafficRedirectHtml = renderTrafficRedirects(locale, props.TrafficRedirects);
            let createActivationButtonHtml;
            const matchValue_5 = (((isVoIP ? true : isTab) ? true : props.GlobalDependencies.IsAdminUser) ? true : ((isMobile ? true : isMobileBroadband) && (networkContractNr == null))) ? true : props.GlobalDependencies.ClientConfig.TelecomEditNumberActive;
            if (matchValue_5) {
                const children_6 = toList(delay(() => append(singleton(wrappedButton(new ButtonKind(0), new ButtonProps(getTranslation("CustomerContract.Invoicee.Subscriptions.CreateActivation"), defaultProps.Content, (_arg) => {
                    createActivationModalIsOpenState[1](true);
                }, defaultProps.Disabled, "open-create-activation-modal-btn", defaultProps.SaveStatus, defaultProps.HTMLProps, defaultProps.ExtraClasses, defaultProps.Icon))), delay(() => {
                    let productType_1;
                    const matchValue_6 = createActivationModalIsOpenState[0];
                    if (matchValue_6) {
                        const productTypeOpt_1 = getProductType(props.Contracts, props.ContractTypes, props.ContractNr);
                        const contractTypeCodeOpt = map((contract) => contract.ContractTypeCode, tryFind(props.ContractNr, props.Contracts));
                        return singleton(renderCreateActivationModal(new CreateActivationProps(props.GlobalDependencies.CountryCode, locale, (productTypeOpt_1 != null) && ((productType_1 = productTypeOpt_1, equals_1(productType_1, new Product(0)) ? true : equals_1(productType_1, new Product(3)))), (number, fromDate, endDateOpt, iccOrImsiOpt) => {
                            const a = saveActivateNumber_1(props.GlobalDependencies.ClientNr, props.ContractNr, props.GlobalDependencies.CountryCode, number, fromDate, endDateOpt, iccOrImsiOpt);
                            return singleton_1.Delay(() => singleton_1.Bind(a, (_arg_1) => singleton_1.Return((props.LoadNumberHistoryFn(), _arg_1))));
                        }, () => {
                            createActivationModalIsOpenState[1](false);
                        }, productTypeOpt_1, contractTypeCodeOpt, (prefix) => loadSearchIccOrImsi(props.GlobalDependencies.ClientNr, prefix))));
                    }
                    else {
                        return singleton(react.createElement(react.Fragment, {}));
                    }
                }))));
                createActivationButtonHtml = react.createElement("div", {}, ...children_6);
            }
            else {
                createActivationButtonHtml = react.createElement(react.Fragment, {});
            }
            let moreInfoButtonHtml;
            const matchValue_7 = props.Sim;
            let pattern_matching_result;
            if (matchValue_7.tag === 1) {
                pattern_matching_result = 0;
            }
            else if (matchValue_7.tag === 2) {
                if (matchValue_7.fields[0] != null) {
                    pattern_matching_result = 1;
                }
                else {
                    pattern_matching_result = 2;
                }
            }
            else {
                pattern_matching_result = 2;
            }
            switch (pattern_matching_result) {
                case 0: {
                    moreInfoButtonHtml = dotsLoading;
                    break;
                }
                case 1: {
                    moreInfoButtonHtml = wrappedButton(new ButtonKind(1), (inputRecord = ButtonProps_get_getDefault(), new ButtonProps(getTranslation("CustomerContract.Invoicee.Subscriptions.Telecom.SimAndDevice"), inputRecord.Content, (_arg_2) => {
                        props.ShowMoreInfoFn(true);
                    }, inputRecord.Disabled, "more-info-btn", inputRecord.SaveStatus, inputRecord.HTMLProps, inputRecord.ExtraClasses, inputRecord.Icon)));
                    break;
                }
                case 2: {
                    moreInfoButtonHtml = (void 0);
                    break;
                }
            }
            let moreInfoModalHtml;
            let historicPortationBoxHtml;
            const children_8 = [renderPortationBox(new PortationBoxProps(props.GlobalDependencies.ClientNr, props.ContractNr, props.GlobalDependencies.SelectedLanguage, new RenderStyle(0), UTCModule_addYears(-3, UTCModule_now()), UTCModule_addDays(365, UTCModule_now())))];
            historicPortationBoxHtml = react.createElement("div", {
                className: "mr-4",
            }, ...children_8);
            let simOrHistoryTableHtml;
            const matchValue_8 = props.SelectedNumberHistoryIndex;
            if (matchValue_8 != null) {
                const index = matchValue_8 | 0;
                const matchValue_9 = tryFind_1((nh) => (nh.Index === index), numberHistories);
                if (matchValue_9 != null) {
                    const nh_1 = matchValue_9;
                    const matchValue_10 = nh_1.ActiveFrom;
                    if (matchValue_10 != null) {
                        const matchValue_11 = [matchValue_10, nh_1.ActiveTo];
                        let pattern_matching_result_1;
                        if (DateTimeOffset_$007CStartsInFuture$007C_$007C(matchValue_11[0], matchValue_11[1]) != null) {
                            pattern_matching_result_1 = 0;
                        }
                        else if (DateTimeOffset_$007CEnded$007C_$007C(matchValue_11[0], matchValue_11[1]) != null) {
                            pattern_matching_result_1 = 0;
                        }
                        else {
                            pattern_matching_result_1 = 1;
                        }
                        switch (pattern_matching_result_1) {
                            case 0: {
                                simOrHistoryTableHtml = renderHistoryTable(getTranslation, locale, nh_1);
                                break;
                            }
                            case 1: {
                                let pattern_matching_result_2;
                                if (DateTimeOffset_$007CEndsInFuture$007C_$007C(matchValue_11[0], matchValue_11[1]) != null) {
                                    pattern_matching_result_2 = 0;
                                }
                                else if (DateTimeOffset_$007COngoing$007C_$007C(matchValue_11[0], matchValue_11[1]) != null) {
                                    pattern_matching_result_2 = 0;
                                }
                                else {
                                    pattern_matching_result_2 = 1;
                                }
                                switch (pattern_matching_result_2) {
                                    case 0: {
                                        const children_13 = [renderSimTable(getTranslation, props.Sim), renderDeviceTable(getTranslation, props.Sim)];
                                        simOrHistoryTableHtml = react.createElement(react.Fragment, {}, ...children_13);
                                        break;
                                    }
                                    case 1: {
                                        simOrHistoryTableHtml = react.createElement(react.Fragment, {});
                                        break;
                                    }
                                }
                                break;
                            }
                        }
                    }
                    else {
                        simOrHistoryTableHtml = react.createElement(react.Fragment, {});
                    }
                }
                else {
                    simOrHistoryTableHtml = react.createElement(react.Fragment, {});
                }
            }
            else {
                simOrHistoryTableHtml = react.createElement(react.Fragment, {});
            }
            let bodyHtml;
            const props_16 = [new HTMLAttr(65, stackClasses(ofArray(["d-flex", "text-left", "mb-4", "justify-content-center"])))];
            bodyHtml = react.createElement("div", keyValueList(props_16, 1), historicPortationBoxHtml, simOrHistoryTableHtml);
            moreInfoModalHtml = modal(props.ShowMoreInfo, render_5(getTranslation("CustomerContract.Invoicee.Subscriptions.Telecom.SimAndDevice"), bodyHtml, new MessageType(0), getTranslation("Common.Close"), (_arg_3) => {
                props.ShowMoreInfoFn(false);
            }));
            let portationTableHtml;
            const now = UTCModule_now();
            const nowDate = UTCModule_date(UTC__get_Year(now), UTC__get_Month(now), UTC__get_Day(now));
            portationTableHtml = renderPortationTable(new PortationTableProps(new InitialState(1, props.GlobalDependencies.ClientNr, props.ContractNr, UTCModule_addYears(-20, nowDate), UTCModule_addYears(20, nowDate)), locale, props.GlobalDependencies.ClientNr, props.ContractNr));
            let pendingRequestsHtml;
            const matchValue_12 = [isVoIP ? true : isTab, usesProvisioningViaSvea];
            let pattern_matching_result_3;
            if (matchValue_12[0]) {
                pattern_matching_result_3 = 0;
            }
            else if (matchValue_12[1]) {
                pattern_matching_result_3 = 1;
            }
            else {
                pattern_matching_result_3 = 0;
            }
            switch (pattern_matching_result_3) {
                case 0: {
                    pendingRequestsHtml = react.createElement(react.Fragment, {});
                    break;
                }
                case 1: {
                    pendingRequestsHtml = renderPlacedOrdersSection(new PlacedOrdersSectionProps(getTranslation, locale, props.GlobalDependencies, props.ContractNr, props.Orders, selectedNumberHistoryOpt, networkContractNr, props.ReloadOrdersFn, props.UpdateNetworkStatusFn));
                    break;
                }
            }
            let deactivateNumberButtonHtml;
            const matchValue_13 = (((isVoIP ? true : isTab) ? true : props.GlobalDependencies.IsAdminUser) ? true : ((isMobile ? true : isMobileBroadband) && (networkContractNr == null))) ? true : props.GlobalDependencies.ClientConfig.TelecomEditNumberActive;
            deactivateNumberButtonHtml = (matchValue_13 ? ((selectedNumberHistoryOpt != null) ? renderDeactivateNumberButton(new DeactivateNumberButtonProps(selectedNumberHistoryOpt.NumberFrom, locale, props.SaveDeactivateNumberFn, props.DeactivateNumberModal.SaveStatus, props.DeactivateNumberConfirmSaveStatusFn)) : (void 0)) : (void 0));
            let flowContainerHtml;
            const _arg_4 = choose((x_1) => x_1, ofArray([numberMenuHtml, props.GlobalDependencies.IsAdminUser ? ((matchValue_15 = [selectedNumberHistoryOpt, props.SelectedNumberHistoryIndex, props.NumberHistory], (matchValue_15[0] != null) ? ((matchValue_15[1] != null) ? ((matchValue_15[2].tag === 2) ? ((currentNumberHistory = matchValue_15[0], (numberHistoryIndex = (matchValue_15[1] | 0), (numberSpecificHistory = filter((nh_3) => (nh_3.NumberFrom === currentNumberHistory.NumberFrom), matchValue_15[2].fields[0]), (matchValue_16 = [map((nsh) => nsh.Index, tryHead(numberSpecificHistory)), map((nsh_1) => nsh_1.Index, tryLast(numberSpecificHistory))], (matchValue_16[0] != null) ? ((matchValue_16[1] != null) ? (((currentNumberHistory.Index === matchValue_16[0]) ? true : (currentNumberHistory.Index === matchValue_16[1])) ? ((firstIndex_1 = (matchValue_16[0] | 0), (lastIndex_1 = (matchValue_16[1] | 0), renderNumberRegisterModification(new NumberRegisterModificationProps(currentNumberHistory, props.SaveNumberRegisterModificationFn, props.NumberRegisterModificationSaveStatus, props.ResetNumberRegisteredModificationFn, Editability_GetEditability(currentNumberHistory.Index, firstIndex_1, lastIndex_1)))))) : (void 0)) : (void 0)) : (void 0)))))) : (void 0)) : (void 0)) : (void 0))) : (void 0), deactivateNumberButtonHtml, moreInfoButtonHtml]));
            flowContainerHtml = (isEmpty(_arg_4) ? react.createElement(react.Fragment, {}) : react.createElement("div", {
                className: "telecom-container__flow",
            }, ..._arg_4));
            let chooseNumberButtonHtml;
            const matchValue_17 = (props.GlobalDependencies.ClientNr === 45619) ? true : (props.GlobalDependencies.ClientNr === 45840);
            if (matchValue_17) {
                let relativeUrl;
                const arg_8 = (selectedNumberHistoryOpt == null) ? int32ToString(props.ContractNr) : selectedNumberHistoryOpt.NumberFrom;
                relativeUrl = toText(printf("/#/NumberInventory/?q=%s"))(arg_8);
                const children_24 = [(children_22 = [wrappedButton(new ButtonKind(1), new ButtonProps(getTranslation("Common.ChooseNumber"), defaultProps.Content, (value) => {
                }, defaultProps.Disabled, "choose-number-btn", defaultProps.SaveStatus, defaultProps.HTMLProps, defaultProps.ExtraClasses, "open_in_browser"))], react.createElement("a", {
                    href: relativeUrl,
                    className: "text-decoration-none",
                }, ...children_22))];
                chooseNumberButtonHtml = react.createElement("div", {}, ...children_24);
            }
            else {
                chooseNumberButtonHtml = react.createElement(react.Fragment, {});
            }
            const children_28 = [react.createElement("div", {
                className: "telecom-container__top-buttons",
            }, createPortationHtml, createActivationButtonHtml, chooseNumberButtonHtml), portationTableHtml, flowContainerHtml, noNumberHistoryMsgHtml, pendingRequestsHtml, trafficRedirectHtml, orderSectionHtml, moreInfoModalHtml];
            return react.createElement("div", {
                className: "telecom-container",
            }, ...children_28);
        }
        default: {
            return react.createElement(react.Fragment, {});
        }
    }
}, "Telecom", uncurry(2, void 0), void 0, "renderTelecom", "E:\\w\\1835\\s\\FenixWebApp\\fable\\src\\Containers\\Telecom\\View.fs", 1328);

export class TelecomProps extends Record {
    constructor(GlobalDependencies, ContractNr, Contracts, ContractTypes, ReloadContractPhoneNumbersFn) {
        super();
        this.GlobalDependencies = GlobalDependencies;
        this.ContractNr = (ContractNr | 0);
        this.Contracts = Contracts;
        this.ContractTypes = ContractTypes;
        this.ReloadContractPhoneNumbersFn = ReloadContractPhoneNumbersFn;
    }
}

export function TelecomProps$reflection() {
    return record_type("Containers.Telecom.View.TelecomProps", [], TelecomProps, () => [["GlobalDependencies", GlobalDependencies$reflection()], ["ContractNr", int32_type], ["Contracts", list_type(Contract$reflection())], ["ContractTypes", class_type("Microsoft.FSharp.Collections.FSharpMap`2", [string_type, ContractType$reflection()])], ["ReloadContractPhoneNumbersFn", lambda_type(unit_type, unit_type)]]);
}

export const view = FunctionComponent_Of_Z5A158BBF((props) => {
    const translationsLoadState = useSelector((state) => state.Model.Translations);
    const contracts = react.useMemo(() => fold((state_1, contract) => add(contract.ContractNumber, contract, state_1), empty_1(), props.Contracts), [props.Contracts, props.GlobalDependencies]);
    const networkContractNrOpt = react.useMemo(() => getNetworkContractNr(props.ContractNr, contracts, props.ContractTypes), [props.ContractNr, contracts, props.ContractTypes]);
    const numberHistoriesLoadState = react.useState(new LoadState$2(0));
    const simLoadState = react.useState(new LoadState$2(0));
    const createPortationSaveState = react.useState(new SaveStatus_1(0));
    const selectedNumberHistoryIndexState = react.useState(void 0);
    const trafficRedirectsState = react.useState(new LoadState$2(0));
    const networkIntegrationNrState = react.useState(new LoadState$2(0));
    const showMoreInfoState = react.useState(false);
    const ordersState = react.useState(new LoadState$2(0));
    const updateNetworkStatus = react.useState(new SaveStatus_1(0));
    const deactivateNumberModalState = react.useState(new DeactivateNumberModal_1(new SaveStatus_1(0)));
    const numberRegisterModificationSaveState = react.useState(new SaveStatus_1(0));
    const numberState = react.useState(void 0);
    const loadOrders = () => {
        if ((ordersState[0]).tag === 2) {
        }
        else {
            ordersState[1](new LoadState$2(1));
        }
        startImmediate(singleton_1.Delay(() => {
            if (networkContractNrOpt != null) {
                const networkContractNr = networkContractNrOpt | 0;
                return singleton_1.Bind(loadOrders_1(props.GlobalDependencies.ClientNr, networkContractNr, props.ContractNr), (_arg_1) => {
                    const result_1 = _arg_1;
                    const arg_4 = (result_1.tag === 0) ? (new LoadState$2(2, result_1.fields[0])) : (new LoadState$2(3, result_1.fields[0]));
                    ordersState[1](arg_4);
                    return singleton_1.Zero();
                });
            }
            else {
                const arg_3 = new LoadState$2(3, getTranslationFrom(translationsLoadState, "CustomerContract.Invoicee.Subscriptions.Telecom.MissingNetworkContractNr"));
                ordersState[1](arg_3);
                return singleton_1.Zero();
            }
        }));
    };
    const saveStatusOrder = (number_1, networkContractNr_1) => {
        startImmediate(singleton_1.Delay(() => singleton_1.Bind(saveStatusOrder_1(props.GlobalDependencies.ClientNr, props.ContractNr, number_1, networkContractNr_1), (_arg_3) => {
            const result_3 = _arg_3;
            if (result_3.tag === 1) {
                updateNetworkStatus[1](new SaveStatus_1(3, result_3.fields[0]));
                return singleton_1.Zero();
            }
            else {
                updateNetworkStatus[1](new SaveStatus_1(2));
                return singleton_1.Zero();
            }
        })));
    };
    const selectNumberHistory = (numberHistories_1, index) => {
        selectedNumberHistoryIndexState[1](index);
        const selectedNumberOpt = map((x) => x.NumberFrom, ((index >= 0) && (index <= (length(numberHistories_1) - 1))) ? item(index, numberHistories_1) : (void 0));
        numberState[1](selectedNumberOpt);
        if (exists((nh_2) => {
            if (nh_2.Index === index) {
                return nh_2.NumberFrom !== nh_2.NumberTo;
            }
            else {
                return false;
            }
        }, numberHistories_1)) {
        }
        else {
            const imsiOpt = bind((nh_1) => nh_1.Imsi, tryFind_1((nh) => (nh.Index === index), numberHistories_1));
            startImmediate(singleton_1.Delay(() => {
                if (imsiOpt != null) {
                    const imsi = imsiOpt;
                    return singleton_1.Combine(((simLoadState[0]).tag === 2) ? ((singleton_1.Zero())) : ((simLoadState[1](new LoadState$2(1)), singleton_1.Zero())), singleton_1.Delay(() => singleton_1.Bind(loadSim_1(props.GlobalDependencies.ClientNr, imsi), (_arg_2) => {
                        const result_2 = _arg_2;
                        const arg_6 = (result_2.tag === 0) ? (new LoadState$2(2, result_2.fields[0])) : (new LoadState$2(3, result_2.fields[0]));
                        simLoadState[1](arg_6);
                        return singleton_1.Zero();
                    })));
                }
                else {
                    return singleton_1.Zero();
                }
            }));
            const selectedNumberHistoryOpt = getSelectedNumberHistory(index, new LoadState$2(2, numberHistories_1));
            if (selectedNumberHistoryOpt != null) {
                const currentNumberHistory = selectedNumberHistoryOpt;
                startImmediate(singleton_1.Delay(() => singleton_1.Combine(((trafficRedirectsState[0]).tag === 2) ? ((singleton_1.Zero())) : ((trafficRedirectsState[1](new LoadState$2(1)), singleton_1.Zero())), singleton_1.Delay(() => singleton_1.Bind(loadTrafficRedirects_1(props.GlobalDependencies.ClientNr, currentNumberHistory.NumberFrom), (_arg_4) => {
                    const result_4 = _arg_4;
                    const arg_9 = (result_4.tag === 0) ? (new LoadState$2(2, result_4.fields[0])) : (new LoadState$2(3, result_4.fields[0]));
                    trafficRedirectsState[1](arg_9);
                    return singleton_1.Zero();
                })))));
                if (networkContractNrOpt != null) {
                    saveStatusOrder(currentNumberHistory.NumberFrom, networkContractNrOpt);
                }
                else {
                    logwi("[Telecom - UpdateNetworkStatus] No NetworkContractNr.");
                }
            }
        }
    };
    const loadNumberHistory = () => {
        const load = () => {
            startImmediate(singleton_1.Delay(() => {
                numberHistoriesLoadState[1](new LoadState$2(1));
                return singleton_1.Bind(loadNumberHistory_1(props.GlobalDependencies.ClientNr, props.ContractNr), (_arg_5) => {
                    const result_5 = _arg_5;
                    if (result_5.tag === 0) {
                        const numberHistories_2 = mapIndexed(NumberHistory_OfDTO, NumberHistoryDTO_SortByActiveFrom_285C6A16(result_5.fields[0]));
                        numberHistoriesLoadState[1](new LoadState$2(2, numberHistories_2));
                        if (!isEmpty(numberHistories_2)) {
                            selectNumberHistory(numberHistories_2, head(numberHistories_2).Index);
                            return singleton_1.Zero();
                        }
                        else {
                            return singleton_1.Zero();
                        }
                    }
                    else {
                        numberHistoriesLoadState[1](new LoadState$2(3, result_5.fields[0]));
                        return singleton_1.Zero();
                    }
                });
            }));
        };
        startImmediate(singleton_1.Delay(() => {
            const matchValue_3 = numberHistoriesLoadState[0];
            switch (matchValue_3.tag) {
                case 0:
                case 3: {
                    load();
                    return singleton_1.Zero();
                }
                case 2: {
                    load();
                    return singleton_1.Zero();
                }
                default: {
                    return singleton_1.Zero();
                }
            }
        }));
    };
    react.useEffect(() => {
        loadOrders();
        loadNumberHistory();
        startImmediate(singleton_1.Delay(() => {
            if (networkContractNrOpt != null) {
                const networkContractNr_4 = networkContractNrOpt | 0;
                return singleton_1.Combine(((networkIntegrationNrState[0]).tag === 2) ? ((singleton_1.Zero())) : ((networkIntegrationNrState[1](new LoadState$2(1)), singleton_1.Zero())), singleton_1.Delay(() => singleton_1.Bind(loadNetworkIntegrationNr_1(props.GlobalDependencies.ClientNr, networkContractNr_4), (_arg_6) => {
                    const result_6 = _arg_6;
                    const arg_19 = (result_6.tag === 0) ? (new LoadState$2(2, result_6.fields[0])) : (new LoadState$2(3, result_6.fields[0]));
                    networkIntegrationNrState[1](arg_19);
                    return singleton_1.Zero();
                })));
            }
            else {
                logii("[LoadNetworkIntegrationNr] Missing NetworkContractNr.");
                return singleton_1.Zero();
            }
        }));
    }, [props.ContractNr, props.GlobalDependencies, props.Contracts, props.ContractTypes]);
    let contentHtml;
    const matchValue_6 = LoadState_zip3(ordersState[0], numberHistoriesLoadState[0], networkIntegrationNrState[0]);
    switch (matchValue_6.tag) {
        case 1: {
            contentHtml = dotsLoading;
            break;
        }
        case 3: {
            contentHtml = error(matchValue_6.fields[0].split(""));
            break;
        }
        case 2: {
            contentHtml = renderTelecom(new RenderTelecomProps(props.ContractNr, props.GlobalDependencies, contracts, props.ContractTypes, numberHistoriesLoadState[0], selectedNumberHistoryIndexState[0], simLoadState[0], trafficRedirectsState[0], createPortationSaveState[0], showMoreInfoState[0], deactivateNumberModalState[0], numberRegisterModificationSaveState[0], networkIntegrationNrState[0], matchValue_6.fields[0][0], partialApply(1, selectNumberHistory, [matchValue_6.fields[0][1]]), loadOrders, (tupledArg) => {
                createPortationSaveState[1](new SaveStatus_1(1));
                const dto = getPortationRequestDTO(props.ContractNr, tupledArg[0], tupledArg[1], tupledArg[2]);
                startImmediate(singleton_1.Delay(() => singleton_1.Bind(saveCreateInportation_1(props.GlobalDependencies.ClientNr, dto), (_arg) => {
                    const result = _arg;
                    const arg = (result.tag === 1) ? (new SaveStatus_1(3, result.fields[0])) : (new SaveStatus_1(2));
                    createPortationSaveState[1](arg);
                    return singleton_1.Zero();
                })));
            }, () => {
                createPortationSaveState[1](new SaveStatus_1(0));
            }, loadNumberHistory, (arg_23) => {
                showMoreInfoState[1](arg_23);
            }, (activeFrom) => {
                startImmediate(singleton_1.Delay(() => {
                    const matchValue_5 = getSelectedNumberHistory(selectedNumberHistoryIndexState[0], numberHistoriesLoadState[0]);
                    if (matchValue_5 != null) {
                        const selectedNumber = matchValue_5;
                        deactivateNumberModalState[1]((x_2) => (new DeactivateNumberModal_1(new SaveStatus_1(1))));
                        return singleton_1.Bind(saveDeactivateNumber_1(props.GlobalDependencies.ClientNr, props.ContractNr, props.GlobalDependencies.CountryCode, selectedNumber.NumberFrom, activeFrom), (_arg_7) => {
                            const result_7 = _arg_7;
                            if (result_7.tag === 0) {
                                deactivateNumberModalState[1]((x_4) => (new DeactivateNumberModal_1(new SaveStatus_1(2))));
                                loadNumberHistory();
                                props.ReloadContractPhoneNumbersFn();
                                return singleton_1.Zero();
                            }
                            else {
                                const msg_7 = result_7.fields[0];
                                logei(msg_7);
                                deactivateNumberModalState[1]((x_3) => (new DeactivateNumberModal_1(new SaveStatus_1(3, msg_7))));
                                return singleton_1.Zero();
                            }
                        });
                    }
                    else {
                        loge("[SaveDeactivateNumber] No selected number history found.");
                        return singleton_1.Zero();
                    }
                }));
            }, () => {
                deactivateNumberModalState[1]((x_5) => (new DeactivateNumberModal_1(new SaveStatus_1(0))));
            }, (tupledArg_1) => {
                numberRegisterModificationSaveState[1](new SaveStatus_1(1));
                startImmediate(singleton_1.Delay(() => singleton_1.Bind(saveNumberRegisterModification_1(props.GlobalDependencies.ClientNr, props.ContractNr, props.GlobalDependencies.CountryCode.TwoLetter, tupledArg_1[0], tupledArg_1[1]), (_arg_8) => {
                    const result_8 = _arg_8;
                    if (result_8.tag === 0) {
                        numberRegisterModificationSaveState[1](new SaveStatus_1(2));
                        loadNumberHistory();
                        return singleton_1.Zero();
                    }
                    else {
                        numberRegisterModificationSaveState[1](new SaveStatus_1(3, result_8.fields[0]));
                        return singleton_1.Zero();
                    }
                })));
            }, () => {
                numberRegisterModificationSaveState[1](new SaveStatus_1(0));
            }, (number_2) => {
                if (networkContractNrOpt != null) {
                    saveStatusOrder(number_2, networkContractNrOpt);
                }
                else {
                    logwi("[Telecom - UpdateNetworkStatus] No NetworkContractNr.");
                }
            }));
            break;
        }
        default: {
            contentHtml = react.createElement(react.Fragment, {});
        }
    }
    return react.createElement("div", {
        className: "telecom",
    }, contentHtml);
}, "TelecomContainer", uncurry(2, void 0), void 0, "view", "E:\\w\\1835\\s\\FenixWebApp\\fable\\src\\Containers\\Telecom\\View.fs", 1668);

